import { Wrapper, TableTitle } from './styles';
import { useMemo } from 'react';
import { useTable } from 'react-table';

const tableHeaders = [
  {
    Header: 'Main tie-ins list',
    columns: [
      {
        Header: 'N°',
        columns: [{ Header: 'N° INVISIBLE', displayNone: true, accessor: 'nr' }],
        rowSpan: 2,
      },
      {
        Header: 'Description',
        columns: [
          {
            Header: 'Description INVISIBLE',
            displayNone: true,
            accessor: 'description',
          },
        ],
        rowSpan: 2,
      },
    ],
  },
  {
    Header: 'Tie-ins details',
    columns: [
      {
        Header: 'Ø',
        columns: [
          {
            Header: 'Inch',
            accessor: 'diameter',
          },
        ],
      },
      {
        Header: 'Rating',
        columns: [
          {
            Header: '#',
            accessor: 'rating',
          },
        ],
      },
      {
        Header: 'Material',
        columns: [
          {
            Header: 'Material INVISIBLE',
            displayNone: true,
            accessor: 'material',
          },
        ],
        rowSpan: 2,
      },
    ],
  },
  {
    Header: 'Tie-in point coordinates',
    columns: [
      {
        Header: 'Tie-in Point N°',
        columns: [
          {
            Header: 'Tie-in INVISIBLE',
            displayNone: true,
            accessor: 'pointNo',
          },
        ],
        rowSpan: 2,
      },
      {
        Header: 'X',
        columns: [{ Header: 'm', colSpan: '3', accessor: 'x' }],
      },
      {
        Header: 'Y',
        columns: [{ Header: 'm INVISIBLE 1', displayNone: true, accessor: 'y' }],
      },
      {
        Header: 'Z',
        columns: [{ Header: 'm INVISIBLE 2', displayNone: true, accessor: 'z' }],
      },
    ],
  },
];

const MainTieIns = ({ tieIns: tableData, tieInsComment, tieInsOtherUtilities, tieInsOtherNetworks }) => {
  const columns = useMemo(() => tableHeaders, []);

  const Table = ({ columns, data }) => {
    const tableInstance = useTable({ columns, data });

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;

    return (
      <table {...getTableProps()}>
        <colgroup>
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
          <col />
        </colgroup>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps()}
                  rowSpan={`${column.rowSpan ?? 1}`}
                  colSpan={`${column.colSpan ?? column.getHeaderProps().colSpan}`}
                  style={column.displayNone ? { display: 'none' } : {}}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  return (
    <Wrapper>
      <TableTitle>{tieInsComment ?? ''}</TableTitle>
      <Table
        columns={columns}
        data={tableData}
      />
      <table>
        <thead>
          <tr>
            <th style={{ borderTop: 'none' }}>Module tie-ins to other utilities</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{tieInsOtherUtilities}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <thead>
          <tr>
            <th style={{ borderTop: 'none' }}>Under deck tie-ins to other networks</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{tieInsOtherNetworks}</td>
          </tr>
        </tbody>
      </table>
    </Wrapper>
  );
};

export default MainTieIns;
